import React from  'react';
import {connect} from 'react-redux';
var hrStyleGlobal ={ 
    margin: '12px 0px 12px -61px', 
    width: '130%' 
};
var topStyleGlobal = {marginLeft: '7px', marginTop: '21px'};

class TopInfo extends React.Component{
    constructor(props) {
        super(props); 
        this.state = {
            title: this.props.title,
            subTitle: this.props.subTitle,
            link: this.props.link,
            style: this.props.style,
            hrStyle: this.props.hrStyle
        }
    }
    render() { 
        if(this.state.hrStyle)
            var hrStyle = this.state.hrStyle;
        else
            var hrStyle = hrStyleGlobal;
        if(this.state.style) {
            var topStyle = this.state.style;
        } else {
            var topStyle = topStyleGlobal;
        }
        var topStyle={display:"none"};
        var dataset_div=null;
        //changed line
        var dataset_name=this.props.dataSet.name;

        if(dataset_name)
            dataset_div=<div className="col-md-12" >
            <span className="text-contrast fa fa-database" data-toggle="tooltip" title="Dataset Name" data-placement="bottom"></span> {dataset_name}</div>;
        return (
            <div style={{margin:'15px 0px',overflow:"auto"}}>
                {dataset_div}
                

                <div style={topStyle}>
                    <h4 style={{ lineHeight: '15%', width: '100%', fontWeight: "bolder", fontSize: "20px", marginBottom: "10px" }}>
                        <a href={null} style={{ textDecoration: 'none' }}>{this.state.title}</a>
                    </h4>
                    <div style={{ fontSize: '15px'}}>{this.state.subTitle}</div>
                    <hr style={hrStyle} />
                </div>
            </div>
        )
    }
};
function mapStateToProps(state)
{
    return{
        dataSet:state.dataSet.dataSet
    }
}
export default connect(mapStateToProps,null)(TopInfo);